// src/Popup.js
import React, { useState } from 'react';

const Popup = ({ isOpen, onClose }) => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded shadow-md w-72">
        <h2 className="text-xl mb-4">Change case Status</h2>
        <hr className='pb-4'/>
        <form>
          <div className="mb-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                className="form-radio text-[#00adb5]"
                name="status"
                value="on hold"
                checked={selectedOption === 'on hold'}
                onChange={handleOptionChange}
                style={{
                  accentColor: '#00adb5' // This is the Tailwind green-600 color
                }}
              />
              <span className="ml-2 text-sm">On Hold</span>
            </label>
          </div>
          <div className="mb-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                className="form-radio text-[#00adb5]"
                name="status"
                value="out of lab"
                checked={selectedOption === 'out of lab'}
                onChange={handleOptionChange}
                style={{
                  accentColor: '#00adb5' 
                }}
              />
              <span className="ml-2 text-sm">Out of Lab</span>
            </label>
          </div>
          <div className="mb-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                className="form-radio text-[#00adb5]"
                name="status"
                value="finished"
                checked={selectedOption === 'finished'}
                onChange={handleOptionChange}
                style={{
                  accentColor: '#00adb5' // This is the Tailwind green-600 color
                }}
              />
              <span className="ml-2 text-sm">Finished</span>
            </label>
          </div>
          <div className="mb-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                className="form-radio text-[#00adb5]"
                name="status"
                value="ready for shipping to doctor"
                checked={selectedOption === 'ready for shipping to doctor'}
                onChange={handleOptionChange}
                style={{
                  accentColor: '#00adb5' // This is the Tailwind green-600 color
                }}
              />
              <span className="ml-2 text-sm">Ready for Shipping to Doctor</span>
            </label>
          </div>
          <div className="mb-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                className="form-radio text-[#00adb5]"
                name="status"
                value="cancelled"
                checked={selectedOption === 'cancelled'}
                onChange={handleOptionChange}
                style={{
                  accentColor: '#00adb5' // This is the Tailwind green-600 color
                }}
              />
              <span className="ml-2 text-sm">Cancelled</span>
            </label>
          </div>
          <hr className='pt-3'/>
        <div className='flex gap-5 justify-end'>
        <button
          className="text-[#00adb5] uppercase"
          onClick={onClose}
        >
          cancel
        </button>

        <button
          className="text-[#00adb5] uppercase"
          onClick={onClose}
        >
          ok
        </button>
        </div>
        </form>
        
      
      </div>
    </div>
  );
};

export default Popup;
